/* eslint-disable no-shadow */
const state = {
	chosenCountry: '',
	countriesWithShipping: '',
	paymentGatewayId: 'cod',
	paymentId: '',
	screenWidth: screen.width,
	tenantConfig: '',
	countryShipping: ''
}

const getters = {
	getSelectedCountry: state => state.chosenCountry,
	getSelectedCountryCode: state => state.chosenCountry.country_code,
	getCountriesWithShipping: state => state.countriesWithShipping,
	getPaymentId: state => state.paymentId,
	getScreenWidth: state => state.screenWidth,
	getPaymentGatewayId: state => state.paymentGatewayId,
	getTenantConfig: state => state.tenantConfig,
	getGiftCardRules: state => state.tenantConfig.gift_card_rule,
	getLoyaltyRules: state => state.tenantConfig.loyalty_creation_rule,
	getShippingCountryDetails: state => state.countryShipping
}

const mutations = {
	setCountryDataMutation: (state, payload) => {
		state.chosenCountry = payload
	},
	setPaymentIdMutation: (state, payload) => {
		state.paymentId = payload
	},
	setPaymentGatewayIdMutation: (state, payload) => {
		state.paymentGatewayId = payload
	},
	setCountriesWithShippingMutation: (state, payload) => {
		state.countriesWithShipping = payload
	},
	setScreenWidthMutation: (state, payload) => {
		state.screenWidth = payload
	},
	setTenantConfigMutation: (state, payload) => {
		state.tenantConfig = payload
	},
	setCountryConfigMutation: (state, payload) => {
		state.countryShipping = payload
	}
}

const actions = {
	setChosenCountryData: ({
		commit
	}, payload) => {
		commit('setCountryDataMutation', payload)
	},
	setPaymentIdData: ({
		commit
	}, payload) => {
		commit('setPaymentIdMutation', payload)
	},
	setPaymentGatewayIdData: ({
		commit
	}, payload) => {
		commit('setPaymentGatewayIdMutation', payload)
	},
	setCountriesWithShipping: ({
		commit
	}, payload) => {
		commit('setCountriesWithShippingMutation', payload)
	},
	setScreenWidthData: ({
		commit
	}, payload) => {
		commit('setScreenWidthMutation', payload)
	},
	setTenantConfig: ({
		commit
	}, payload) => {
		commit('setTenantConfigMutation', payload)
	},
	setCountryConfig: ({
		commit
	}, payload) => {
		commit('setCountryConfigMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
